


















































































































































































































































































































































































































































































































































































































































































































































































































































import isEmail from 'validator/lib/isEmail';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import CoWeekdaySelector from '@/components/Molecules/co-weekday-selector/CoWeekdaySelector.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoImage from '@/components/Atoms/co-image/CoImage.vue';
import CoLoadingIndicator from '@/components/Atoms/co-loading-indicator/coLoadingIndicator.vue';
import CoCheckbox from '@/components/Atoms/co-checkbox/CoCheckbox.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';
import CoCardUpgrade from '@/components/Molecules/co-card-upgrade/CoCardUpgrade.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import { SUPPORTED_IMAGE_ACCEPT } from '@/constants/fileUpload';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import type { WeekdaySelectorDay, WeekdaySelectorValue } from '@/components/Molecules/co-weekday-selector/models.ts';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoAlert from '../../Molecules/co-alert/CoAlert.vue';
import CoLink from '../../Atoms/co-link/CoLink.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoSwitch from '../../Atoms/co-switch/CoSwitch.vue';
import CoCollapsible from '../../Molecules/co-collapsible/CoCollapsible.vue';
import CoFormGroup from '../../Molecules/co-form-group/CoFormGroup.vue';
import CoInput from '../../Molecules/co-input/CoInput.vue';
import CoMultiselect from '../../Molecules/co-multiselect/CoMultiSelect.vue';
import CoSelect from '../../Molecules/co-select/CoSelect.vue';
import CoModal from '../co-modal/CoModal.vue';
import CoRules from '../co-rules/CoRules.vue';
import { mapRuleFromBackend, mapRuleToBackend, Rule } from '../co-rules/models.ts';
import {
    BookingResource,
    BookingResourceBlockingRule,
    BookingResourceBookingTime,
    BookingGranularityType,
    BookingResourceCalendarToken,
    BookingResourceDateOverrideDraft,
    BookingResourceDayBookingConfiguration,
    BookingResourceExternalCalendar,
    BookingResourceLocationOption,
    BookingResourceLockOption,
    BookingResourceTaxRate,
    CheckOutDayType,
    BookingResourceUpgrade,
    cloneBookingResourceBlockingRule,
    cloneBookingResource,
    cloneBookingResourceDateOverrideDraft,
    cloneBookingResourceUpgrade,
    createBookingResourceDayBookingConfiguration,
    createBookingResourceBookingTime,
    createBookingResourceDateOverrideDraft,
} from './models.ts';
import CoDragDropFileUpload from '../co-drag-drop-file-upload/CoDragDropFileUpload.vue';
import CoTagList from '../co-TagList/coTagList.vue';
import CoTextArea from '../../Molecules/co-TextArea/CoTextArea.vue';

interface SelectOption {
    Name: string;
    Value: string | number | null;
    Disabled: boolean;
}

type DurationUnit = 'minutes' | 'hours' | 'days';

const EMPTY_SELECT_OPTION: SelectOption = {
    Name: '',
    Value: null,
    Disabled: false,
};

const DURATION_UNIT_MULTIPLIER: Record<DurationUnit, number> = {
    minutes: 1,
    hours: 60,
    days: 60 * 24,
};

function createEmptyRule(): Rule {
    return {
        ConditionsGroups: [],
        CombineWithOR: false,
    };
}

export default {
    name: 'CoBookingResource',
    components: {
        CoAlert,
        CoCardUpgrade,
        CoCheckbox,
        CoCollapsible,
        CoDropdown,
        CoDropdownItem,
        CoFormGroup,
        CoInput,
        CoLink,
        CoModal,
        CoMultiselect,
        CoRules,
        CoSelect,
        CoSwitch,
        CoTable,
        CoText,
        CoEditor,
        CoWeekdaySelector,
        CoTippy,
        CoDragDropFileUpload,
        CoImage,
        CoLoadingIndicator,
        CoRoundButton,
        CoConfirmation,
        CoCard,
        CoTextArea,
        CoTagList,
        CoButton,
        CoHeadline,
    },
    model: {
        prop: 'resource',
        event: 'input',
    },
    props: {
        resource: {
            type: Object,
            required: true,
        },
        locations: {
            type: Array,
            default: () => [] as BookingResourceLocationOption[],
        },
        taxRates: {
            type: Array,
            default: () => [] as BookingResourceTaxRate[],
        },
        availableResources: {
            type: Array,
            default: () => [] as BookingResource[],
        },
        calendarTokens: {
            type: Array,
            default: () => [] as BookingResourceCalendarToken[],
        },
        calendarOptions: {
            type: Array,
            default: () => [] as BookingResourceExternalCalendar[],
        },
        availableLocks: {
            type: Array,
            default: () => [] as BookingResourceLockOption[],
        },
        availableUpgrades: {
            type: Array,
            default: () => [] as BookingResourceUpgrade[],
        },
        billingEnabled: {
            type: Boolean,
            default: true,
        },
        hasActivePlans: {
            type: Boolean,
            default: true,
        },
        accessManagementEnabled: {
            type: Boolean,
            default: false,
        },
        currency: {
            type: String,
            default: 'EUR',
        },
    },
    data() {
        return {
            editedResource: cloneBookingResource(this.resource as BookingResource),
            imagePreviewUrl: (this.resource as BookingResource).ImageURL || null,
            selectedImage: null,
            selectedImageFile: null as File | null,
            newImageUploading: false,
            lastEmittedResourceSignature: '',
            syncingFromProp: false,
            minBookingDurationUnit: 'minutes' as DurationUnit,
            maxBookingDurationUnit: 'minutes' as DurationUnit,
            imageAccept: SUPPORTED_IMAGE_ACCEPT,
            dateOverridesDraft: [] as BookingResourceDateOverrideDraft[],
            selectedTokenId: null as string | null,
            selectedCalendarId: null as string | null,
            selectedLockIds: [] as string[],
            validTimeBeforeBooking: 10,
            validTimeAfterBooking: 10,
            candidateBlockingRule: null as BookingResourceBlockingRule | null,
            candidateBlockingRuleKey: 1,
            editingBlockingRuleResourceId: null as string | null,
            candidateUpgrade: null as BookingResourceUpgrade | null,
            candidateUpgradeKey: 1,
            notifyEmailListKey: 1,
            whoCanSeeRulesDraft: createEmptyRule(),
            whoCanBookRulesDraft: createEmptyRule(),
            resourceNamePlaceholder: '{{resource_name}}',
            upgradesPlaceholder: '{{upgrades}}',
            commentPlaceholder: '{{comment}}',
            fromPlaceholder: '{{from}}',
            toPlaceholder: '{{to}}',
        };
    },
    computed: {
        locationItems(): SelectOption[] {
            return this.locations.map((location: BookingResourceLocationOption) => ({
                Name: location.Name,
                Value: location.ID,
                Disabled: false,
            }));
        },
        selectedLocation(): SelectOption | null {
            if (this.editedResource.LocationID === null || this.editedResource.LocationID === undefined) {
                return EMPTY_SELECT_OPTION;
            }

            return (
                this.locationItems.find((item) => item.Value === this.editedResource.LocationID) || EMPTY_SELECT_OPTION
            );
        },
        taxRateItems(): SelectOption[] {
            return this.taxRates.map((taxRate: BookingResourceTaxRate) => ({
                Name: `${taxRate.Percentage || 0}% - ${taxRate.DisplayName}`,
                Value: taxRate.ID,
                Disabled: false,
            }));
        },
        bookingGranularityItems(): SelectOption[] {
            return [
                {
                    Name: this.$t('labels.bookinggranularity15minutes'),
                    Value: BookingGranularityType.BookingGranularity15Minutes,
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.bookinggranularity30minutes'),
                    Value: BookingGranularityType.BookingGranularity30Minutes,
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.bookinggranularityhour'),
                    Value: BookingGranularityType.BookingGranularityHour,
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.bookinggranularityday'),
                    Value: BookingGranularityType.BookingGranularityDay,
                    Disabled: false,
                },
            ];
        },
        durationUnitItems(): SelectOption[] {
            const unitItems = [
                {
                    Name: this.$t('labels.minutes'),
                    Value: 'minutes',
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.hours'),
                    Value: 'hours',
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.days'),
                    Value: 'days',
                    Disabled: false,
                },
            ];

            if (this.isDayBookingGranularity) {
                // Day bookings use check-in and checkout for exact times, so duration limits stay day-based.
                return unitItems.filter((item) => item.Value === 'days');
            }

            return unitItems;
        },
        currentPriceDisplayUnitOption(): SelectOption {
            if (this.editedResource.PricePerSlot) {
                return {
                    Name: this.$t('labels.priceperslot'),
                    Value: 'slot',
                    Disabled: false,
                };
            }

            if (this.isDayBookingGranularity) {
                return {
                    Name: this.$t('labels.priceperday'),
                    Value: 'day',
                    Disabled: false,
                };
            }

            return {
                Name: this.$t('labels.priceperhour'),
                Value: 'hour',
                Disabled: false,
            };
        },
        priceDisplayUnitItems(): SelectOption[] {
            return [this.currentPriceDisplayUnitOption];
        },
        selectedBookingGranularity(): SelectOption | null {
            return (
                this.bookingGranularityItems.find(
                    (item) => item.Value === this.getEffectiveBookingGranularity(this.editedResource.BookingGranularity)
                ) || EMPTY_SELECT_OPTION
            );
        },
        selectedPriceDisplayUnit(): SelectOption | null {
            return this.currentPriceDisplayUnitOption;
        },
        selectedMinBookingDurationUnit(): SelectOption | null {
            return this.getSelectedDurationUnit(this.minBookingDurationUnit);
        },
        selectedMaxBookingDurationUnit(): SelectOption | null {
            return this.getSelectedDurationUnit(this.maxBookingDurationUnit);
        },
        capacityValue: {
            get(): number {
                return this.editedResource.Capacity || 1;
            },
            set(value: string | number) {
                // CoInput emits strings for number inputs, so keep the resource payload numeric.
                const normalizedValue = Number(value);
                this.editedResource.Capacity =
                    Number.isFinite(normalizedValue) && normalizedValue > 0 ? Math.round(normalizedValue) : 1;
            },
        },
        cancellationPeriodValue: {
            get(): number {
                return Number(this.editedResource.CancellationPeriod) || 0;
            },
            set(value: string | number) {
                // Cancellation period is stored in whole hours and should never become negative.
                const normalizedValue = Number(value);
                this.editedResource.CancellationPeriod =
                    Number.isFinite(normalizedValue) && normalizedValue >= 0 ? Math.round(normalizedValue) : 0;
            },
        },
        isDayBookingGranularity(): boolean {
            return (
                this.getEffectiveBookingGranularity(this.editedResource.BookingGranularity) ===
                BookingGranularityType.BookingGranularityDay
            );
        },
        checkOutDayItems(): SelectOption[] {
            return [
                {
                    Name: this.$t('labels.sameday'),
                    Value: CheckOutDayType.CheckOutDaySameDay,
                    Disabled: false,
                },
                {
                    Name: this.$t('labels.followingday'),
                    Value: CheckOutDayType.CheckOutDayFollowingDay,
                    Disabled: false,
                },
            ];
        },
        selectedCheckOutDay(): SelectOption | null {
            const dayBooking = this.getDayBookingConfiguration();
            return (
                this.checkOutDayItems.find(
                    (item) => item.Value === (dayBooking?.CheckOutDay || CheckOutDayType.CheckOutDaySameDay)
                ) || EMPTY_SELECT_OPTION
            );
        },
        selectedTaxRate(): SelectOption | null {
            if (!this.editedResource.TaxRateID) {
                return EMPTY_SELECT_OPTION;
            }

            return (
                this.taxRateItems.find((item) => item.Value === this.editedResource.TaxRateID) || EMPTY_SELECT_OPTION
            );
        },
        blockingResourceItems(): SelectOption[] {
            return this.availableResources
                .filter((resource: BookingResource) => resource.ID !== this.editedResource.ID)
                .map((resource: BookingResource) => ({
                    Name: resource.Name,
                    Value: resource.ID || null,
                    Disabled: false,
                }));
        },
        blockingRuleTableItems(): Array<BookingResourceBlockingRule & { ResourceName: string }> {
            return this.editedResource.Rules.map((rule: BookingResourceBlockingRule) => ({
                ...rule,
                ResourceName: this.getBlockingRuleResourceName(rule.BlockResourceID),
            }));
        },
        availableBlockingRuleItems(): SelectOption[] {
            const candidateResourceId = this.candidateBlockingRule?.BlockResourceID || null;
            const selectedRuleIds = this.editedResource.Rules.map(
                (rule: BookingResourceBlockingRule) => rule.BlockResourceID
            ).filter((resourceId: string) => resourceId && resourceId !== candidateResourceId);

            return this.blockingResourceItems.filter(
                (item) => item.Value === candidateResourceId || !selectedRuleIds.includes(item.Value as string)
            );
        },
        selectedBlockingRuleOption(): SelectOption | null {
            if (!this.candidateBlockingRule?.BlockResourceID) {
                return EMPTY_SELECT_OPTION;
            }

            return (
                this.availableBlockingRuleItems.find(
                    (item) => item.Value === this.candidateBlockingRule?.BlockResourceID
                ) || {
                    Name: this.getBlockingRuleResourceName(this.candidateBlockingRule.BlockResourceID),
                    Value: this.candidateBlockingRule.BlockResourceID,
                    Disabled: false,
                }
            );
        },
        calendarTokenItems(): SelectOption[] {
            return this.calendarTokens.map((token: BookingResourceCalendarToken) => ({
                Name: token.Name || this.formatCalendarToken(token),
                Value: token.ID,
                Disabled: false,
            }));
        },
        selectedCalendarToken(): SelectOption | null {
            if (!this.selectedTokenId) {
                return EMPTY_SELECT_OPTION;
            }

            return this.calendarTokenItems.find((item) => item.Value === this.selectedTokenId) || EMPTY_SELECT_OPTION;
        },
        calendarItems(): SelectOption[] {
            const filteredCalendars = this.selectedTokenId
                ? this.calendarOptions.filter(
                      (calendar: BookingResourceExternalCalendar) =>
                          (calendar.TokenID || calendar.tokenID || '') === this.selectedTokenId
                  )
                : this.calendarOptions;

            return filteredCalendars.map((calendar: BookingResourceExternalCalendar) => ({
                Name: calendar.Name,
                Value: calendar.ID,
                Disabled: false,
            }));
        },
        selectedCalendarOption(): SelectOption | null {
            if (!this.selectedCalendarId) {
                return EMPTY_SELECT_OPTION;
            }

            return this.calendarItems.find((item) => item.Value === this.selectedCalendarId) || EMPTY_SELECT_OPTION;
        },
        selectedCalendarDetails(): BookingResourceExternalCalendar | null {
            if (!this.selectedCalendarId) {
                return null;
            }

            const syncedCalendar =
                this.editedResource.ExternalCalendars.find(
                    (calendar: BookingResourceExternalCalendar) => calendar.ID === this.selectedCalendarId
                ) || null;
            const availableCalendar =
                this.calendarOptions.find(
                    (calendar: BookingResourceExternalCalendar) => calendar.ID === this.selectedCalendarId
                ) || null;

            if (syncedCalendar && availableCalendar) {
                // Merge the live sync metadata from the resource response into the prefetched calendar option.
                return {
                    ...availableCalendar,
                    ...syncedCalendar,
                    TokenID:
                        syncedCalendar.TokenID ||
                        syncedCalendar.tokenID ||
                        availableCalendar.TokenID ||
                        availableCalendar.tokenID ||
                        '',
                    tokenID:
                        syncedCalendar.tokenID ||
                        syncedCalendar.TokenID ||
                        availableCalendar.tokenID ||
                        availableCalendar.TokenID ||
                        '',
                };
            }

            return syncedCalendar || availableCalendar || null;
        },
        lockItems(): SelectOption[] {
            return this.availableLocks.map((lock: BookingResourceLockOption) => ({
                Name: lock.Provider ? `${lock.Name} - ${lock.Provider}` : lock.Name,
                Value: lock.ID,
                Disabled: false,
            }));
        },
        selectedLocks(): SelectOption[] {
            if (this.selectedLockIds.length === 0) {
                return [];
            }

            return this.lockItems.filter((item) => this.selectedLockIds.includes(item.Value as string));
        },
        availableUpgradeCandidates(): BookingResourceUpgrade[] {
            // Keep the add modal deduplicated by hiding upgrades already assigned to the resource.
            const selectedUpgradeIds = this.editedResource.Upgrades.map((upgrade) => upgrade.OriginalID || upgrade.ID);
            return this.availableUpgrades
                .filter(
                    (upgrade: BookingResourceUpgrade) => !selectedUpgradeIds.includes(upgrade.OriginalID || upgrade.ID)
                )
                .map((upgrade: BookingResourceUpgrade) => cloneBookingResourceUpgrade(upgrade));
        },
        pricePerHour: {
            get(): number {
                return this.editedResource.PriceInCentsPerHour / 100;
            },
            set(value: string | number) {
                const normalizedValue = Number(value) || 0;
                this.editedResource.PriceInCentsPerHour = Math.round(normalizedValue * 100);
            },
        },
        minBookingDurationValue: {
            get(): number {
                return this.convertMinutesToDurationUnit(
                    this.editedResource.MinBookingDuration,
                    this.minBookingDurationUnit
                );
            },
            set(value: string | number) {
                this.editedResource.MinBookingDuration = this.convertDurationUnitToMinutes(
                    value,
                    this.minBookingDurationUnit
                );
                this.normalizeBookingDurationRange();
            },
        },
        maxBookingDurationValue: {
            get(): number {
                return this.convertMinutesToDurationUnit(
                    this.editedResource.MaxBookingDuration,
                    this.maxBookingDurationUnit
                );
            },
            set(value: string | number) {
                this.editedResource.MaxBookingDuration = this.convertDurationUnitToMinutes(
                    value,
                    this.maxBookingDurationUnit
                );
                this.normalizeBookingDurationRange();
            },
        },
        dayBookingCheckInTime: {
            get(): string {
                return this.formatTimeOfDay(this.getDayBookingConfiguration()?.CheckInTime);
            },
            set(value: string) {
                this.updateDayBookingTime('CheckInTime', value);
            },
        },
        dayBookingCheckOutTime: {
            get(): string {
                return this.formatTimeOfDay(this.getDayBookingConfiguration()?.CheckOutTime);
            },
            set(value: string) {
                this.updateDayBookingTime('CheckOutTime', value);
            },
        },
    },
    watch: {
        resource: {
            deep: true,
            handler(newValue: BookingResource) {
                const normalizedResource = cloneBookingResource(newValue);
                const incomingSignature = JSON.stringify(normalizedResource);
                if (incomingSignature === this.lastEmittedResourceSignature) {
                    this.lastEmittedResourceSignature = '';
                    return;
                }

                this.applyResourceState(normalizedResource);
            },
        },
        editedResource: {
            deep: true,
            handler(newValue: BookingResource) {
                if (this.syncingFromProp) {
                    return;
                }

                if (!this.selectedImageFile) {
                    this.imagePreviewUrl = newValue.ImageURL || null;
                }

                const emittedResource = cloneBookingResource(newValue);
                this.lastEmittedResourceSignature = JSON.stringify(emittedResource);
                this.$emit('input', emittedResource);
                this.$emit('change', emittedResource);
            },
        },
        dateOverridesDraft: {
            deep: true,
            handler() {
                if (this.syncingFromProp) {
                    return;
                }

                this.editedResource.BookingTimeOverride = this.buildBookingTimeOverride();
            },
        },
        selectedTokenId() {
            if (this.syncingFromProp) {
                return;
            }

            if (!this.calendarItems.find((item) => item.Value === this.selectedCalendarId)) {
                this.selectedCalendarId = null;
            }
            this.syncExternalCalendars();
        },
        selectedCalendarId() {
            if (this.syncingFromProp) {
                return;
            }

            this.syncExternalCalendars();
        },
        selectedLockIds() {
            if (this.syncingFromProp) {
                return;
            }

            this.syncLocks();
        },
        validTimeBeforeBooking() {
            if (this.syncingFromProp) {
                return;
            }

            this.syncLocks();
        },
        validTimeAfterBooking() {
            if (this.syncingFromProp) {
                return;
            }

            this.syncLocks();
        },
    },
    created() {
        this.applyResourceState(cloneBookingResource(this.resource as BookingResource));
    },
    methods: {
        applyResourceState(resource: BookingResource) {
            this.syncingFromProp = true;
            const normalizedResource = cloneBookingResource({
                ...resource,
                NotifyEmails: this.normalizeNotificationEmails(resource.NotifyEmails),
            });
            this.editedResource = normalizedResource;
            this.normalizeDayBookingDurationValues();
            this.normalizeBookingDurationRange();
            // Keep the editor flexible while still emitting minute-based values to the backend.
            this.minBookingDurationUnit = this.isDayBookingGranularity
                ? 'days'
                : this.getDurationUnitFromMinutes(normalizedResource.MinBookingDuration);
            this.maxBookingDurationUnit = this.isDayBookingGranularity
                ? 'days'
                : this.getDurationUnitFromMinutes(normalizedResource.MaxBookingDuration);
            this.imagePreviewUrl = normalizedResource.ImageURL || null;
            this.selectedImageFile = null;
            this.dateOverridesDraft = this.parseBookingTimeOverride(normalizedResource.BookingTimeOverride);
            this.candidateBlockingRule = null;
            this.candidateBlockingRuleKey = 1;
            this.editingBlockingRuleResourceId = null;
            this.selectedTokenId = this.getSelectedTokenId(normalizedResource.ExternalCalendars);
            this.selectedCalendarId =
                normalizedResource.ExternalCalendars && normalizedResource.ExternalCalendars[0]
                    ? normalizedResource.ExternalCalendars[0].ID
                    : null;
            this.selectedLockIds = Array.isArray(normalizedResource.Locks)
                ? normalizedResource.Locks.map((lock) => lock.ID).filter((lockId) => !!lockId)
                : [];
            this.validTimeBeforeBooking =
                normalizedResource.Locks && normalizedResource.Locks[0]
                    ? normalizedResource.Locks[0].BeforeUnitXTimesBeforBookingStart || 0
                    : 10;
            this.validTimeAfterBooking =
                normalizedResource.Locks && normalizedResource.Locks[0]
                    ? normalizedResource.Locks[0].AfterUnitXTimesAfterBookingEnd || 0
                    : 10;
            this.candidateUpgrade = null;
            this.candidateUpgradeKey = 1;
            this.notifyEmailListKey += 1;
            this.whoCanSeeRulesDraft = this.parsePermissionRule(
                normalizedResource.WhoCanSee,
                normalizedResource.WhoCanSeeCombineWithOR
            );
            this.whoCanBookRulesDraft = this.parsePermissionRule(
                normalizedResource.WhoCanBook,
                normalizedResource.WhoCanBookCombineWithOR
            );
            this.$nextTick(() => {
                this.syncingFromProp = false;
            });
        },
        parsePermissionRule(conditionsGroups: BookingResource['WhoCanSee'], combineWithOr: boolean): Rule {
            if (!conditionsGroups || conditionsGroups.length === 0) {
                return createEmptyRule();
            }

            return mapRuleFromBackend({
                ConditionsGroups: conditionsGroups,
                CombineWithOR: combineWithOr || false,
            });
        },
        updateWhoCanSeeRules(rules: Rule) {
            this.whoCanSeeRulesDraft = rules;
            this.syncPermissionRules();
        },
        updateWhoCanBookRules(rules: Rule) {
            this.whoCanBookRulesDraft = rules;
            this.syncPermissionRules();
        },
        syncPermissionRules() {
            if (this.syncingFromProp) {
                return;
            }

            const mappedWhoCanSee = mapRuleToBackend(this.whoCanSeeRulesDraft);
            this.editedResource.WhoCanSee = mappedWhoCanSee.ConditionsGroups || [];
            this.editedResource.WhoCanSeeCombineWithOR = mappedWhoCanSee.CombineWithOR || false;

            const mappedWhoCanBook = mapRuleToBackend(this.whoCanBookRulesDraft);
            this.editedResource.WhoCanBook = mappedWhoCanBook.ConditionsGroups || [];
            this.editedResource.WhoCanBookCombineWithOR = mappedWhoCanBook.CombineWithOR || false;
        },
        parseBookingTimeOverride(
            bookingTimeOverride: Record<string, { From: string; To: string; Block: boolean; IsAllDay: boolean }>
        ): BookingResourceDateOverrideDraft[] {
            const entries = Object.keys(bookingTimeOverride || {}).map((dateKey) =>
                cloneBookingResourceDateOverrideDraft({
                    date: dateKey,
                    from: bookingTimeOverride[dateKey]?.From || '09:00',
                    to: bookingTimeOverride[dateKey]?.To || '17:00',
                    Block: !!bookingTimeOverride[dateKey]?.Block,
                    IsAllDay: !!bookingTimeOverride[dateKey]?.IsAllDay,
                })
            );

            return entries;
        },
        buildBookingTimeOverride() {
            return this.dateOverridesDraft.reduce((result, currentOverride) => {
                if (!currentOverride.date) {
                    return result;
                }

                return {
                    ...result,
                    [currentOverride.date]: {
                        From: currentOverride.from,
                        To: currentOverride.to,
                        Block: !!currentOverride.Block,
                        IsAllDay: !!currentOverride.Block,
                    },
                };
            }, {});
        },
        getBookingTimeWeekdays(bookingTime: BookingResourceBookingTime): WeekdaySelectorDay[] {
            // Adapt the stored weekday numbers to the selector's richer value shape.
            return [1, 2, 3, 4, 5, 6, 7].map((value) => ({
                caption: '',
                state: bookingTime.Weekdays.includes(value),
                value: value as WeekdaySelectorValue,
            }));
        },
        getEffectiveBookingGranularity(granularity: BookingGranularityType): BookingGranularityType {
            if (
                granularity === BookingGranularityType.BookingGranularityUndefined ||
                granularity === null ||
                granularity === undefined
            ) {
                return BookingGranularityType.BookingGranularity30Minutes;
            }

            return granularity;
        },
        getDurationUnitFromMinutes(value: number): DurationUnit {
            const normalizedValue = Number(value) || 0;

            if (normalizedValue > 0 && normalizedValue % DURATION_UNIT_MULTIPLIER.days === 0) {
                return 'days';
            }

            if (normalizedValue > 0 && normalizedValue % DURATION_UNIT_MULTIPLIER.hours === 0) {
                return 'hours';
            }

            return 'minutes';
        },
        convertMinutesToDurationUnit(value: number, unit: DurationUnit): number {
            const normalizedValue = Number(value) || 0;
            if (unit === 'days' && this.isDayBookingGranularity) {
                return this.convertMinutesToDayBookingDays(normalizedValue);
            }

            const convertedValue = normalizedValue / DURATION_UNIT_MULTIPLIER[unit];

            return Number.isInteger(convertedValue) ? convertedValue : Number(convertedValue.toFixed(2));
        },
        convertDurationUnitToMinutes(value: string | number, unit: DurationUnit): number {
            const normalizedValue = Number(value);

            if (!Number.isFinite(normalizedValue) || normalizedValue < 0) {
                return 0;
            }

            if (unit === 'days' && this.isDayBookingGranularity) {
                return this.convertDayBookingDaysToMinutes(normalizedValue);
            }

            return Math.round(normalizedValue * DURATION_UNIT_MULTIPLIER[unit]);
        },
        getDayBookingBaseDurationInMinutes(): number {
            // One booking day is the configured check-in to checkout span, not always a fixed 24 hours.
            const dayBooking = this.getDayBookingConfiguration();
            const checkIn = dayBooking?.CheckInTime || { Hour: 0, Minute: 0 };
            const checkOut = dayBooking?.CheckOutTime || { Hour: 0, Minute: 0 };
            const checkInMinutes = (Number(checkIn.Hour) || 0) * 60 + (Number(checkIn.Minute) || 0);
            const checkOutMinutes = (Number(checkOut.Hour) || 0) * 60 + (Number(checkOut.Minute) || 0);
            const checkoutOffset =
                dayBooking?.CheckOutDay === CheckOutDayType.CheckOutDayFollowingDay ? DURATION_UNIT_MULTIPLIER.days : 0;
            const baseDuration = checkoutOffset + checkOutMinutes - checkInMinutes;

            return baseDuration > 0 ? baseDuration : DURATION_UNIT_MULTIPLIER.days;
        },
        convertDayBookingDaysToMinutes(value: number): number {
            if (value <= 0) {
                return 0;
            }

            const normalizedDays = Math.max(1, Math.round(value));
            const fullDaysAfterFirstDay = normalizedDays - 1;
            return Math.round(
                this.getDayBookingBaseDurationInMinutes() + fullDaysAfterFirstDay * DURATION_UNIT_MULTIPLIER.days
            );
        },
        convertMinutesToDayBookingDays(value: number): number {
            if (value <= 0) {
                return 0;
            }

            const baseDuration = this.getDayBookingBaseDurationInMinutes();
            const convertedValue = 1 + (value - baseDuration) / DURATION_UNIT_MULTIPLIER.days;
            const normalizedValue = Math.max(0, convertedValue);

            return Number.isInteger(normalizedValue) ? normalizedValue : Number(normalizedValue.toFixed(2));
        },
        normalizeDayBookingDurationValues() {
            if (!this.isDayBookingGranularity) {
                return;
            }

            // Normalize loaded legacy minute values into whole booking days for the day-only duration UI.
            this.editedResource.MinBookingDuration = this.normalizeDayBookingDurationInMinutes(
                this.editedResource.MinBookingDuration
            );
            this.editedResource.MaxBookingDuration = this.normalizeDayBookingDurationInMinutes(
                this.editedResource.MaxBookingDuration
            );
        },
        normalizeDayBookingDurationInMinutes(value: number): number {
            const normalizedValue = Number(value) || 0;

            if (normalizedValue <= 0) {
                return 0;
            }

            const baseDuration = this.getDayBookingBaseDurationInMinutes();
            const dayCount = Math.max(
                1,
                Math.round(1 + (normalizedValue - baseDuration) / DURATION_UNIT_MULTIPLIER.days)
            );
            return this.convertDayBookingDaysToMinutes(dayCount);
        },
        normalizeBookingDurationRange() {
            const minBookingDuration = Number(this.editedResource.MinBookingDuration) || 0;
            const maxBookingDuration = Number(this.editedResource.MaxBookingDuration) || 0;

            if (maxBookingDuration === 0 || maxBookingDuration >= minBookingDuration) {
                return;
            }

            // Keep duration rules valid by preserving "no maximum" while raising too-short maximum values.
            this.editedResource.MaxBookingDuration = minBookingDuration;
        },
        getSelectedDurationUnit(unit: DurationUnit): SelectOption | null {
            return this.durationUnitItems.find((item) => item.Value === unit) || EMPTY_SELECT_OPTION;
        },
        getDayBookingConfiguration(): BookingResourceDayBookingConfiguration | null {
            return this.editedResource.DayBooking || null;
        },
        ensureDayBookingConfiguration(): BookingResourceDayBookingConfiguration {
            if (!this.editedResource.DayBooking) {
                // Initialize a valid day-booking draft when a legacy resource switches to day granularity.
                this.editedResource.DayBooking = createBookingResourceDayBookingConfiguration();
            }

            return this.editedResource.DayBooking;
        },
        selectBookingGranularity(option: SelectOption) {
            const nextGranularity = option
                ? (option.Value as BookingGranularityType)
                : BookingGranularityType.BookingGranularityUndefined;
            const isSwitchingToDayGranularity = nextGranularity === BookingGranularityType.BookingGranularityDay;
            const minDurationValue = isSwitchingToDayGranularity
                ? 0
                : this.convertMinutesToDurationUnit(
                      this.editedResource.MinBookingDuration,
                      this.minBookingDurationUnit
                  );
            const maxDurationValue = isSwitchingToDayGranularity
                ? 0
                : this.convertMinutesToDurationUnit(
                      this.editedResource.MaxBookingDuration,
                      this.maxBookingDurationUnit
                  );

            this.editedResource.BookingGranularity = nextGranularity;

            if (isSwitchingToDayGranularity) {
                this.ensureDayBookingConfiguration();
                // whole slot booking and price per slot don't make sense for day booking, reset them when switching to day granularity
                this.editedResource.BookWholeSlot = false;
                this.editedResource.PricePerSlot = false;

                this.editedResource.BookingTimes = this.createDayBookingTimesFromCurrentAvailability();
                this.minBookingDurationUnit = 'days';
                this.maxBookingDurationUnit = 'days';
                // Convert existing minute-based limits into whole booking-day limits.
                this.normalizeDayBookingDurationValues();
                this.normalizeBookingDurationRange();
                return;
            }

            this.editedResource.MinBookingDuration = this.convertDurationUnitToMinutes(
                minDurationValue,
                this.minBookingDurationUnit
            );
            this.editedResource.MaxBookingDuration = this.convertDurationUnitToMinutes(
                maxDurationValue,
                this.maxBookingDurationUnit
            );
            this.normalizeBookingDurationRange();
        },
        selectMinBookingDurationUnit(option: SelectOption) {
            const nextUnit = (option?.Value as DurationUnit) || 'minutes';
            this.minBookingDurationUnit = this.changeBookingDurationUnit(
                'MinBookingDuration',
                this.minBookingDurationUnit,
                this.getEffectiveDurationUnit(nextUnit)
            );
        },
        selectMaxBookingDurationUnit(option: SelectOption) {
            const nextUnit = (option?.Value as DurationUnit) || 'minutes';
            this.maxBookingDurationUnit = this.changeBookingDurationUnit(
                'MaxBookingDuration',
                this.maxBookingDurationUnit,
                this.getEffectiveDurationUnit(nextUnit)
            );
        },
        getEffectiveDurationUnit(unit: DurationUnit): DurationUnit {
            return this.isDayBookingGranularity ? 'days' : unit;
        },
        changeBookingDurationUnit(
            field: 'MinBookingDuration' | 'MaxBookingDuration',
            currentUnit: DurationUnit,
            nextUnit: DurationUnit
        ): DurationUnit {
            if (currentUnit === nextUnit) {
                return nextUnit;
            }

            // Preserve the visible number when the admin changes units; only the stored minute value changes.
            const currentValue = this.convertMinutesToDurationUnit(this.editedResource[field], currentUnit);
            this.editedResource[field] = this.convertDurationUnitToMinutes(currentValue, nextUnit);
            this.normalizeBookingDurationRange();
            return nextUnit;
        },
        updateDayBookingDurationMinutes(minDays: number, maxDays: number) {
            this.editedResource.MinBookingDuration = this.convertDurationUnitToMinutes(minDays, 'days');
            this.editedResource.MaxBookingDuration = this.convertDurationUnitToMinutes(maxDays, 'days');
            this.normalizeBookingDurationRange();
        },
        preserveDayBookingDurationValues(callback: () => void) {
            if (!this.isDayBookingGranularity) {
                callback();
                return;
            }

            const minDays = this.convertMinutesToDurationUnit(this.editedResource.MinBookingDuration, 'days');
            const maxDays = this.convertMinutesToDurationUnit(this.editedResource.MaxBookingDuration, 'days');
            callback();
            // Recalculate minutes so changing check-in/checkout keeps the same displayed day counts.
            this.updateDayBookingDurationMinutes(minDays, maxDays);
        },
        selectCheckOutDay(option: SelectOption) {
            this.preserveDayBookingDurationValues(() => {
                const dayBooking = this.ensureDayBookingConfiguration();
                dayBooking.CheckOutDay = option
                    ? (option.Value as CheckOutDayType)
                    : CheckOutDayType.CheckOutDaySameDay;
            });
        },
        formatTimeOfDay(timeOfDay?: { Hour: number; Minute: number } | null): string {
            if (!timeOfDay) {
                return '';
            }

            return `${String(timeOfDay.Hour || 0).padStart(2, '0')}:${String(timeOfDay.Minute || 0).padStart(2, '0')}`;
        },
        parseTimeOfDay(value: string) {
            const [hour, minute] = (value || '').split(':');
            const normalizedHour = Number(hour);
            const normalizedMinute = Number(minute);

            return {
                Hour: Number.isInteger(normalizedHour) ? normalizedHour : 0,
                Minute: Number.isInteger(normalizedMinute) ? normalizedMinute : 0,
            };
        },
        updateDayBookingTime(field: 'CheckInTime' | 'CheckOutTime', value: string) {
            this.preserveDayBookingDurationValues(() => {
                const dayBooking = this.ensureDayBookingConfiguration();
                dayBooking[field] = this.parseTimeOfDay(value);
            });
        },
        selectLocation(option: SelectOption) {
            this.editedResource.LocationID = option ? option.Value : null;
        },
        selectTaxRate(option: SelectOption) {
            this.editedResource.TaxRateID = option ? (option.Value as string | null) : null;
        },
        createDayBookingTimesFromCurrentAvailability(): BookingResourceBookingTime[] {
            const bookingTimes = Array.isArray(this.editedResource.BookingTimes)
                ? this.editedResource.BookingTimes
                : [];
            const selectedWeekdays = bookingTimes.reduce((weekdays, bookingTime) => {
                (bookingTime.Weekdays || []).forEach((weekday) => weekdays.add(weekday));
                return weekdays;
            }, new Set<number>());

            if (selectedWeekdays.size === 0) {
                // Preserve no weekly availability when switching to day granularity.
                return [];
            }

            return [
                createBookingResourceBookingTime({
                    From: '00:00',
                    To: '00:00',
                    Weekdays: [...selectedWeekdays].sort((left, right) => left - right),
                }),
            ];
        },
        addBookingTime() {
            this.editedResource.BookingTimes.push(createBookingResourceBookingTime());
        },
        removeBookingTime(index: number) {
            this.editedResource.BookingTimes.splice(index, 1);
        },
        updateBookingTimeWeekdays(index: number, weekdays: WeekdaySelectorDay[]) {
            const bookingTime = this.editedResource.BookingTimes[index];
            if (!bookingTime) {
                return;
            }

            bookingTime.Weekdays = weekdays
                .filter((weekday) => weekday.state)
                .map((weekday) => weekday.value)
                .sort((left, right) => left - right);
        },
        addDateOverride() {
            this.dateOverridesDraft.push(createBookingResourceDateOverrideDraft());
        },
        removeDateOverride(index: number) {
            this.dateOverridesDraft.splice(index, 1);
        },
        toggleDateOverrideBlock(index: number, value: boolean) {
            const currentOverride = this.dateOverridesDraft[index];
            if (!currentOverride) {
                return;
            }

            currentOverride.Block = value;
            currentOverride.IsAllDay = value;
        },
        normalizeNotificationEmails(tags?: string[] | null) {
            return (Array.isArray(tags) ? tags : []).map((tag) => (tag || '').trim()).filter((tag) => tag.length > 0);
        },
        isNotificationEmail(value: string) {
            return isEmail((value || '').trim());
        },
        updateNotificationEmails(tags: string[]) {
            // Keep notify emails in sync with the tag list so the parent resource emit stays unchanged.
            this.editedResource.NotifyEmails = this.normalizeNotificationEmails(tags);
        },
        openAddBlockingRuleModal() {
            this.candidateBlockingRule = cloneBookingResourceBlockingRule();
            this.candidateBlockingRuleKey += 1;
            this.editingBlockingRuleResourceId = null;
            const modal = this.$refs['add-blocking-rule-modal'] as { show?: () => void } | undefined;
            modal?.show?.();
        },
        editBlockingRule(rule: BookingResourceBlockingRule) {
            this.candidateBlockingRule = cloneBookingResourceBlockingRule(rule);
            this.candidateBlockingRuleKey += 1;
            this.editingBlockingRuleResourceId = rule.BlockResourceID;
            const modal = this.$refs['add-blocking-rule-modal'] as { show?: () => void } | undefined;
            modal?.show?.();
        },
        selectBlockingRuleResource(option: SelectOption) {
            if (!this.candidateBlockingRule) {
                return;
            }

            this.candidateBlockingRule.BlockResourceID = option ? (option.Value as string) || '' : '';
        },
        saveBlockingRuleCandidate() {
            if (!this.candidateBlockingRule?.BlockResourceID) {
                return;
            }

            const candidateBlockingRule = cloneBookingResourceBlockingRule({
                ...this.candidateBlockingRule,
                NumberOfSlots: Math.max(1, Number(this.candidateBlockingRule.NumberOfSlots) || 1),
            });
            if (
                this.editingBlockingRuleResourceId &&
                this.editingBlockingRuleResourceId !== candidateBlockingRule.BlockResourceID
            ) {
                this.editedResource.Rules = this.editedResource.Rules.filter(
                    (rule) => rule.BlockResourceID !== this.editingBlockingRuleResourceId
                );
            }
            const existingRuleIndex = this.editedResource.Rules.findIndex(
                (rule: BookingResourceBlockingRule) => rule.BlockResourceID === candidateBlockingRule.BlockResourceID
            );

            if (existingRuleIndex >= 0) {
                this.editedResource.Rules.splice(existingRuleIndex, 1, candidateBlockingRule);
            } else {
                this.editedResource.Rules.push(candidateBlockingRule);
            }

            this.discardBlockingRuleCandidate();
        },
        discardBlockingRuleCandidate() {
            this.candidateBlockingRule = null;
            this.candidateBlockingRuleKey += 1;
            this.editingBlockingRuleResourceId = null;
            const modal = this.$refs['add-blocking-rule-modal'] as { hide?: () => void } | undefined;
            modal?.hide?.();
        },
        removeBlockingRuleFromForm(resourceId?: string) {
            if (!resourceId) {
                return;
            }

            this.editedResource.Rules = this.editedResource.Rules.filter((rule) => rule.BlockResourceID !== resourceId);
        },
        getBlockingRuleResourceName(resourceId: string): string {
            const resource = this.availableResources.find((entry: BookingResource) => entry.ID === resourceId);
            return resource ? resource.Name : resourceId;
        },
        formatCalendarToken(token: BookingResourceCalendarToken): string {
            if (token.CreatedAt) {
                return `${token.ID.slice(0, 12)}... - ${this.formatTimestamp(token.CreatedAt)}`;
            }

            return token.ID;
        },
        selectCalendarToken(option: SelectOption) {
            this.selectedTokenId = option ? (option.Value as string | null) : null;
        },
        selectCalendar(option: SelectOption) {
            this.selectedCalendarId = option ? (option.Value as string | null) : null;
        },
        getSelectedTokenId(calendars: BookingResourceExternalCalendar[]): string | null {
            if (!calendars || calendars.length === 0) {
                return null;
            }

            return calendars[0].TokenID || calendars[0].tokenID || null;
        },
        syncExternalCalendars() {
            if (!this.selectedCalendarId || !this.selectedTokenId) {
                this.editedResource.ExternalCalendars = [];
                return;
            }

            const selectedCalendar = this.calendarOptions.find(
                (calendar: BookingResourceExternalCalendar) => calendar.ID === this.selectedCalendarId
            );

            if (!selectedCalendar) {
                this.editedResource.ExternalCalendars = [];
                return;
            }

            this.editedResource.ExternalCalendars = [
                {
                    ID: selectedCalendar.ID,
                    Name: selectedCalendar.Name,
                    TokenID: this.selectedTokenId,
                    tokenID: this.selectedTokenId,
                    SyncToken: selectedCalendar.SyncToken || '',
                    Subscribed: !!selectedCalendar.Subscribed,
                    ChannelExpiration: selectedCalendar.ChannelExpiration || 0,
                    LastSync: selectedCalendar.LastSync || 0,
                },
            ];
        },
        selectLocks(options: SelectOption[]) {
            this.selectedLockIds = Array.isArray(options)
                ? options.map((option) => option?.Value as string).filter((lockId) => !!lockId)
                : [];
        },
        syncLocks() {
            if (this.selectedLockIds.length === 0) {
                this.editedResource.Locks = [];
                return;
            }

            const selectedLocks = this.selectedLockIds
                .map((selectedLockId) =>
                    this.availableLocks.find((lock: BookingResourceLockOption) => lock.ID === selectedLockId)
                )
                .filter((lock): lock is BookingResourceLockOption => !!lock);
            if (selectedLocks.length === 0) {
                this.editedResource.Locks = [];
                return;
            }

            // Reuse the shared validity values for every selected lock.
            this.editedResource.Locks = selectedLocks.map((selectedLock: BookingResourceLockOption) => ({
                ID: selectedLock.ID,
                Name: selectedLock.Name,
                Action: 0,
                BeforeUnitXTimesBeforBookingStart: Number(this.validTimeBeforeBooking) || 0,
                BeforeUnit: 0,
                AfterUnitXTimesAfterBookingEnd: Number(this.validTimeAfterBooking) || 0,
                AfterUnit: 0,
            }));
        },
        openAddUpgradeModal() {
            this.candidateUpgrade = null;
            this.candidateUpgradeKey += 1;
            const modal = this.$refs['add-booking-upgrade-modal'] as { show?: () => void } | undefined;
            modal?.show?.();
        },
        syncResource() {
            if (!this.selectedCalendarId || !this.editedResource.ID) {
                return;
            }

            // Keep the legacy sync entrypoint while delegating persistence and the API call
            // to the create/edit wrapper that owns the resource lifecycle.
            this.$emit('request-calendar-sync', this.selectedCalendarId);
        },
        toggleMinAmount(value: boolean) {
            if (!this.candidateUpgrade) {
                return;
            }

            this.candidateUpgrade.MinAmount = value ? 1 : 0;
            this.candidateUpgradeKey += 1;
        },
        toggleMaxAmount(value: boolean) {
            if (!this.candidateUpgrade) {
                return;
            }

            this.candidateUpgrade.MaxAmount = value ? 1 : 0;
            this.candidateUpgradeKey += 1;
        },
        goToCreateUpgrade() {
            window.open(`https://${window.location.hostname}/admin/monetization/plan-upgrade/create`, '_blank');
        },
        editUpgrade(upgrade: BookingResourceUpgrade) {
            this.candidateUpgrade = cloneBookingResourceUpgrade(upgrade);
            this.candidateUpgradeKey += 1;
            const modal = this.$refs['add-booking-upgrade-modal'] as { show?: () => void } | undefined;
            modal?.show?.();
        },
        removeUpgradeFromForm(id?: string) {
            if (!id) {
                return;
            }

            this.editedResource.Upgrades = this.editedResource.Upgrades.filter(
                (upgrade) => (upgrade.OriginalID || upgrade.ID) !== id
            );
        },
        saveUpdateCandidate() {
            if (!this.candidateUpgrade) {
                return;
            }

            const candidateUpgrade = cloneBookingResourceUpgrade(this.candidateUpgrade);
            const existingUpgradeIndex = this.editedResource.Upgrades.findIndex(
                (upgrade) => (upgrade.OriginalID || upgrade.ID) === candidateUpgrade.OriginalID
            );

            if (existingUpgradeIndex >= 0) {
                this.editedResource.Upgrades.splice(existingUpgradeIndex, 1, candidateUpgrade);
            } else {
                this.editedResource.Upgrades.push(candidateUpgrade);
            }

            this.discardUpgradeCandidate();
        },
        discardUpgradeCandidate() {
            this.candidateUpgrade = null;
            this.candidateUpgradeKey += 1;
            const modal = this.$refs['add-booking-upgrade-modal'] as { hide?: () => void } | undefined;
            modal?.hide?.();
        },
        deleteUpgrade() {
            this.candidateUpgrade = null;
            this.candidateUpgradeKey += 1;
        },
        selectUpgrade(_event?: string, upgrades?: BookingResourceUpgrade[]) {
            if (!upgrades || upgrades.length === 0) {
                return;
            }

            const [selectedUpgrade] = upgrades;
            this.candidateUpgrade = cloneBookingResourceUpgrade({
                ...selectedUpgrade,
                OriginalID: selectedUpgrade.OriginalID || selectedUpgrade.ID,
                MinAmount: 0,
                MaxAmount: 0,
            });
            this.candidateUpgradeKey += 1;
        },
        formatTimestamp(timestamp: number): string {
            const normalizedTimestamp = timestamp > 1000000000000 ? timestamp : timestamp * 1000;
            return new Date(normalizedTimestamp).toLocaleString();
        },
        openImagePicker() {
            const imageInput = this.$refs.imageInput as HTMLInputElement | undefined;
            imageInput?.click();
        },
        handleImageSelected(image) {
            if (image && image.filePreview) {
                // Store preview and file for upload on submit.
                // this.newImage = image.filePreview;
                // this.newImageFile = image.file;

                this.selectedImageFile = image.file;
                this.editedResource.ImageURL = null;
                const reader = new FileReader();
                reader.onload = () => {
                    this.imagePreviewUrl = typeof reader.result === 'string' ? reader.result : null;
                };
                reader.readAsDataURL(image.file);
                this.$emit('image-selected', image.file);
            }
        },
        removeImage() {
            this.selectedImage = null;
            this.selectedImageFile = null;
            this.imagePreviewUrl = null;
            this.editedResource.ImageURL = null;
            const imageInput = this.$refs.imageInput as HTMLInputElement | undefined;
            if (imageInput) {
                imageInput.value = '';
            }
            this.$emit('image-selected', null);
        },
        resetSelectedImage() {
            if (!this.editedResource.ImageURL) {
                return;
            }

            this.selectedImageFile = null;
            this.imagePreviewUrl = this.editedResource.ImageURL;
            this.$emit('image-selected', null);
        },
    },
};
